import { motion } from "framer-motion";
import logo from "../../assets/home/logo.png";
import { FaGraduationCap, FaBookReader, FaAward } from "react-icons/fa";

export default function About() {
  return (
    <section className="relative bg-white py-24 px-6 lg:px-20 overflow-hidden">
      {/* Decorative Background Blur Blobs */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-50 rounded-full blur-3xl opacity-60 translate-x-1/3 -translate-y-1/4 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-red-50 rounded-full blur-3xl opacity-60 -translate-x-1/3 translate-y-1/4 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16 items-center relative z-10">
        
        {/* Text Content */}
        <motion.div
          className="lg:col-span-7 flex flex-col justify-center"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-blue-50 border border-blue-100 text-[#1a237e] text-sm font-bold tracking-wider uppercase shadow-sm w-fit">
            Welcome to Selva's
          </div>
          
          <h2 className="text-4xl md:text-5xl font-extrabold mb-8 text-gray-900 leading-tight">
            About <span className="text-red-700">Our IAS Academy</span>
          </h2>

          <div className="bg-white/80 backdrop-blur-xl rounded-2xl border border-gray-100 shadow-xl shadow-blue-900/5 p-6 md:p-8 lg:p-10 transition-shadow hover:shadow-2xl hover:shadow-blue-900/10">
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              At Selva’s IAS Academy, we nurture the conviction that every
              aspirant can excel with the right mentorship and discipline.{" "}
              <span className="font-semibold text-red-700 bg-red-50 px-2 py-0.5 rounded leading-normal">
                Our pedagogy emphasizes conceptual clarity, analytical aptitude,
                and examination strategy.
              </span>
            </p>
            <p className="text-gray-600 leading-relaxed mb-8">
              Distinguished faculty and mentors offer individualized guidance
              throughout the journey. We integrate structured courses, evaluative
              assessments, and constructive feedback for sustained growth. With
              unwavering commitment, we serve as a trusted companion in your
              pursuit of the Civil Services.
            </p>
            
            {/* Quick feature highlights */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-6 border-t border-gray-100">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-blue-50 flex flex-shrink-0 items-center justify-center text-blue-600 shadow-sm border border-blue-100">
                  <FaGraduationCap size={22} />
                </div>
                <span className="text-sm font-bold text-gray-800">Expert Mentorship</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-red-50 flex flex-shrink-0 items-center justify-center text-red-600 shadow-sm border border-red-100">
                  <FaBookReader size={22} />
                </div>
                <span className="text-sm font-bold text-gray-800">Structured Courses</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-green-50 flex flex-shrink-0 items-center justify-center text-green-600 shadow-sm border border-green-100">
                  <FaAward size={22} />
                </div>
                <span className="text-sm font-bold text-gray-800">Proven Results</span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Image container */}
        <motion.div
          className="lg:col-span-5 flex justify-center lg:justify-end mt-8 lg:mt-0"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="relative group px-4 py-4 md:px-8 w-full max-w-sm sm:max-w-md">
            {/* Tilted background card */}
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-100 to-red-50 rounded-3xl transform -rotate-3 transition-transform group-hover:rotate-0 duration-500 shadow-lg"></div>
            {/* Main logo image on top */}
            <img
              src={logo}
              alt="Selva's IAS Academy"
              className="relative rounded-[2rem] shadow-2xl z-10 w-full h-auto bg-white p-6 md:p-8 object-contain transition-transform duration-500 group-hover:-translate-y-2 border border-white"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
